<template>
  <div class="wrapper">
    <div v-if="Object.keys(items).length !== 0" class="table">
      <table>
        <caption>Информация о розыгрыше</caption>
        <thead>
          <tr>
            <td v-for="(header, index) in headersLottery" :key="index">{{ header.text }}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="(header, index) in headersLottery" :key="index">{{ items[header.value] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="no-data">Нет информации о розыгрыше</div>

    <div v-if="winners.length > 0" class="table">
      <table ref="sortable">
        <caption>Информация о победителях</caption>
        <thead>
          <tr>
            <td v-for="(header, index) in headersWinners" :key="index" @click="sortTable(index)">
              {{ header.text }}
              <span v-if="header.sortable !== false">
                {{ sortOrder.direction === 'asc' ? '▲' : '▼' }}
              </span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, i) in sortedWinners" :key="i">
            <td>
              <v-btn
                v-if="isAdmin"
                text
                small
                :to="{ name: 'user', params: { user: user.id } }"
                class="btn"
              >
                {{ user.id }}
              </v-btn>
              <span v-else>{{ user.id }}</span>
            </td>
            <td>
              <v-btn
                v-if="isAdmin"
                text
                small
                :to="{ name: 'user', params: { user: user.id } }"
                class="btn"
              >
                {{ user.name }}
              </v-btn>
              <span v-else>{{ user.name }}</span>
            </td>
            <td>{{ user.participation_at }}</td>
          </tr>
        </tbody>
      </table>

      <v-pagination
        v-model="page"
        :length="Math.ceil(winnersCount / itemsPerPage)"
        circle
      />
    </div>

    <div v-else class="no-data">Нет информации о победителях</div>
  </div>
</template>

<script>
import User from '../../helpers/user'
import { getLottery } from '../../api/lotteries'

export default {
  name: 'Lottery',
  data () {
    return {
      headersLottery: [
        { text: 'Lottery ID', value: 'id' },
        { text: 'ID создателя розыгрыша', value: 'user_id' },
        { text: 'Сумма выигрыша', value: 'win_amount' },
        { text: 'Количество победителей', value: 'count_winners' },
        { text: 'Дата и время создания розыгрыша', value: 'created_at' },
        { text: 'Дата и время окончания розыгрыша', value: 'finished_at' },
        { text: 'Условие по рефералу', value: 'condition_only_referrals' },
        { text: 'Условие по статусу', value: 'condition_allowed_statuses' },
        { text: 'Условие по сумме пополнения', value: 'condition_replenishment_sum' },
        { text: 'Условие по сроку пополнения', value: 'condition_replenishment_from' }
      ],
      headersWinners: [
        { text: 'ID победителя', value: 'id' },
        { text: 'Ник победителя', value: 'name' },
        { text: 'Дата и время участия', sortable: false }
      ],
      loading: true,
      sortOrder: { column: null, direction: 'asc' },
      items: [],
      winnersCount: 1,
      winners: [],
      page: 1,
      itemsPerPage: 25
    }
  },
  computed: {
    isAdmin () {
      return User.hasAdminAccess()
    },
    sortedWinners () {
      const { column, direction } = this.sortOrder
      if (column !== null)
        return this.winners.slice().sort((a, b) => {
          const aValue = a[this.headersWinners[column].value]
          const bValue = b[this.headersWinners[column].value]

          if (direction === 'asc')
            return aValue > bValue ? 1 : -1

          return aValue < bValue ? 1 : -1

        })

      return this.winners
    }
  },
  watch: {
    page () {
      this.pullFunction()
    }
  },
  created () {
    this.pullFunction()
  },
  mounted () {
    this.$emit('title_changed', `Розыгрыш №: ${this.$route.params.lottery}`)
  },
  methods: {
    pullFunction () {
      const numberToTextMap = {
        0: 'New',
        1: 'Bronze',
        2: 'Silver',
        3: 'Gold',
        4: 'Platinum',
        5: 'Diamond'
      }

      getLottery(
        { limit: this.itemsPerPage, offset: (this.page - 1) * this.itemsPerPage },
        this.$route.params.lottery
      ).then(res => {
        this.items = res.data
        this.items.condition_allowed_statuses = this.items.condition_allowed_statuses
          .map(number => numberToTextMap[number]).join(', ')
        this.winners = res.data.winners
        this.winnersCount = res.data.count_winners
        this.loading = false
      })
    },
    sortTable (columnIndex) {
      if (this.headersWinners[columnIndex].sortable !== false)
        if (this.sortOrder.column === columnIndex) {
          this.sortOrder.direction = this.sortOrder.direction === 'asc' ? 'desc' : 'asc'
        } else {
          this.sortOrder.column = columnIndex
          this.sortOrder.direction = 'desc'
        }

    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 70px;

  .table {
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    table {
      width: 100%;
      border-collapse: collapse;
    }

    caption {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 10px;
    }

    th, td {
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
    }
  }

  .btn {
    width: 100%;
    box-shadow: none !important;
    background: none !important;
  }

  span {
    font-size: 14px;
    margin: 0;
  }

  .no-data {
    margin: 0 auto;
    font-size: 18px;
    font-weight: 600;
  }
}
</style>
